import { render, staticRenderFns } from "./aecResource.vue?vue&type=template&id=b3d5c232&"
import script from "./aecResource.vue?vue&type=script&lang=js&"
export * from "./aecResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports